<template>
  <div>
    <unit-card @openSearchComponent="openClasseUnitSearch"/>
  </div>
</template>

<script>
import UnitCard from '@/components/unit-card'

export default {
  name: 'classe-upload-header',
  components: { UnitCard },
  methods: {
    openClasseUnitSearch () {
      this.$emit('openClasseUnitSearch')
    }
  }
}
</script>

<style>

</style>
